import React from 'react'
import { styled, useTheme } from '@mui/material'
import { WithCloseButton } from 'packages/eid-ui'

const Wrapper = styled('div')(({ styles, theme }) => ({
    backgroundColor: theme?.palette?.background?.paper,
    width: '100%',
    maxWidth: '425px',
    margin: 'auto',
    ...styles,
    overflow: 'hidden',
}))

const ItemsDetailsMobileWrapper = ({
    children,
    styles,
    toggleDrawer,
    withCloseIcon,
}) => {
    const theme = useTheme()

    return (
        <Wrapper styles={styles}>
            {withCloseIcon ? (
                <WithCloseButton
                    color={theme?.palette?.common?.black}
                    iconPosition={{ top: '20px', right: 0 }}
                    onClose={toggleDrawer}
                >
                    {children}
                </WithCloseButton>
            ) : (
                children
            )}
        </Wrapper>
    )
}

export default ItemsDetailsMobileWrapper
